import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreTaskData } from './coreTaskData';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { HttpError } from '../errors';
import * as Raven from 'raven-js';

@Injectable()
export class CoreTaskDataService {
  private dataRetrievalErrorBase = new Subject<boolean>();
  public dataRetrievalError$ = this.dataRetrievalErrorBase.asObservable();

  private dataPostErrorBase = new Subject<boolean>();
  public dataPostError$ = this.dataPostErrorBase.asObservable();

  private dataPostSuccess = new Subject<boolean>();
  public dataPostSuccess$ = this.dataPostSuccess.asObservable();

  private signaturePostError = new Subject<boolean>();
  public signaturePostError$ = this.signaturePostError.asObservable();

  private signaturePostSuccess = new Subject();
  public signaturePostSuccess$ = this.signaturePostSuccess.asObservable();

  private signatureRetrievalError = new Subject<boolean>();
  public signatureRetrievalError$ = this.signatureRetrievalError.asObservable();

  constructor(private http: HttpClient) { }

  getCoreTaskData(coreTaskId: string): any {
    return this.http.get<CoreTaskData>(`/kerntaken/${coreTaskId}/gegevens`).pipe(catchError(error => {
      this.dataRetrievalErrorBase.next(false);
      throw new HttpError(`Error retrieving data for coreTaskId: ${coreTaskId}`);
    }));
  }

  getCoreTaskDataCache(): any {
    return this.http.get<CoreTaskData>(`/kerntaken/cache`).pipe(catchError(error => {
      this.dataRetrievalErrorBase.next(false);
      throw new HttpError(`Error retrieving data for coreTask cache`);
    }));
  }

  postCoreTaskData(coreTaskId: string, data: CoreTaskData) {
    return this.http.post(`/kerntaken/${coreTaskId}/gegevens`, data)
      .map(items => {
        this.dataPostSuccess.next(true);
      })
      .pipe(catchError(error => {
        this.dataPostErrorBase.next(false);
        throw new HttpError(`Error posting data for coreTaskId: ${coreTaskId}`)
      }));
  }

  getCoreTaskSignature(coreTaskId: string, type: string): any {
    return this.http.get<CoreTaskData>(`/kerntaken/${coreTaskId}/handtekening?type=${type}`).pipe(catchError(error => {
      this.signatureRetrievalError.next(false);
      throw new HttpError(`Error retrieving signature for coreTaskId: ${coreTaskId}`);
    }));
  }

  postCoreTaskSignature(coreTaskId: string, type: string, data) {
    return this.http.post(`/kerntaken/${coreTaskId}/handtekening`, {
      handtekening: data,
      type: type
    })
      .map(() => {
        this.signaturePostSuccess.next();
      })
      .pipe(catchError(error => {
        this.dataPostErrorBase.next(false);
        throw new HttpError(`Error posting signature for coreTaskId: ${coreTaskId}`)
      }));
  }

  postCoreTaskSignatureSignLater(coreTaskId: string) {
    return this.http.post(`/kerntaken/${coreTaskId}/laterondertekenen`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/core-task-data.service.ts